import {
  EQUIFAX_VIC_BUILD_IDENTIFIERS,
  EQUIFAX_VIC_BUILD_IDENTIFIERS_SUCCESS,
  EQUIFAX_VIC_BUILD_IDENTIFIERS_FAIL,

  EQUIFAX_VIC_SELECT_IDENTIFIER,
  EQUIFAX_VIC_SELECT_IDENTIFIER_SUCCESS,
  EQUIFAX_VIC_SELECT_IDENTIFIER_FAIL,

  EQUIFAX_VIC_LIST_DOCUMENTS,
  EQUIFAX_VIC_LIST_DOCUMENTS_SUCCESS,
  EQUIFAX_VIC_LIST_DOCUMENTS_FAIL,

  EQUIFAX_VIC_PLACE_ORDER,
  EQUIFAX_VIC_PLACE_ORDER_SUCCESS,
  EQUIFAX_VIC_PLACE_ORDER_FAIL,
} from '../actions/vic-property-cert';


export const initialState = {
  data: null,
  loading: false,
  error: null,
  select_identifier: { loading: false, error: null },
  list_documents: { loading: false, error: null },
  place_order: { loading: false, error: null },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case EQUIFAX_VIC_BUILD_IDENTIFIERS:
      return {
        ...state,
        data: null,
        error: null,
        loading: true,
      };
    case EQUIFAX_VIC_BUILD_IDENTIFIERS_SUCCESS:
      return {
        ...state,
        data: action.payload,
        error: null,
        loading: false,
      };
    case EQUIFAX_VIC_BUILD_IDENTIFIERS_FAIL:
      return {
        ...state,
        data: null,
        error: action.error,
        loading: false,
      };
    case EQUIFAX_VIC_SELECT_IDENTIFIER:
      return {
        ...state,
        select_identifier: { error: null, loading: true },
      };
    case EQUIFAX_VIC_SELECT_IDENTIFIER_SUCCESS:
      return {
        ...state,
        data: {
          ...(state && state.data),
          ...{ selectIdentifier: action.payload },
        },
        select_identifier: { error: null, loading: false },
      };
    case EQUIFAX_VIC_SELECT_IDENTIFIER_FAIL:
      return {
        ...state,
        select_identifier: { error: action.error, loading: false },
      };
    case EQUIFAX_VIC_LIST_DOCUMENTS:
      return {
        ...state,
        list_documents: { error: null, loading: true },
      };
    case EQUIFAX_VIC_LIST_DOCUMENTS_SUCCESS:
      return {
        ...state,
        data: {
          ...(state && state.data),
          ...{ documents: action.payload },
        },
        list_documents: { error: null, loading: false },
      };
    case EQUIFAX_VIC_LIST_DOCUMENTS_FAIL:
      return {
        ...state,
        list_documents: { error: action.error, loading: false },
      };
    case EQUIFAX_VIC_PLACE_ORDER:
      return {
        ...state,
        place_order: { error: null, loading: true },
      };
    case EQUIFAX_VIC_PLACE_ORDER_SUCCESS:
      return {
        ...state,
        data: {
          ...(state && state.data),
          ...{ response: action.payload },
        },
        place_order: { error: null, loading: false },
      };
    case EQUIFAX_VIC_PLACE_ORDER_FAIL:
      return {
        ...state,
        place_order: { error: action.error, loading: false },
      };
    default:
      return state;
  }
};
